export enum DashboardTypes {
  anomaly = "anomaly",
  loudness = "loudness",
  combined = "combined",
  combined_pro = "combined_pro",
}
